<template lang="js">
<div class="dialog-window window-background">
    <div class="window-title">
        <span>{{ title }}</span>
        <img class="close-btn" src="../../assets/common/btn_close_window.png" alt="" @click="switchDirectory">
    </div>
    <div class="window-content">
        <slot></slot>
    </div>
</div>
</template>
<script>
export default {
    name: "common-window",
    props: {
        title: String
    },
    methods: {
        switchDirectory() {
            this.$emit('close');
        }
    }
}
</script>
<style src="../../css/window_style.css" scoped>

</style>
<style lang="css" scoped>

</style>